// @flow
import * as React from 'react';
import { Box, Text } from 'gestalt';

type Props = {||};

const Dot = (props: Props) => (
  <Box display="flex" justifyContent="center" paddingX={1}>
    <Text size="sm" color="darkGray" bold>
      &middot;
    </Text>
  </Box>
);

export default Dot;
